export default __webpack_public_path__ + "static/media/AAA Dark.c41677bd.svg";